/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinanceDictionaryDto } from '../models/FinanceDictionaryDto';
import type { FinanceProposalDto } from '../models/FinanceProposalDto';
import type { LenderTypeEnum } from '../models/LenderTypeEnum';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FinanceProposalService {

  /**
   * @param lender
 *
 * 1 = Encore
 *
 * 2 = Genus
 *
 * 3 = Santander
   * @returns FinanceDictionaryDto Success
   * @throws ApiError
   */
  public static getProposalsIndividualDictionaries(
lender?: LenderTypeEnum,
): CancelablePromise<FinanceDictionaryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/proposals/individual/dictionaries',
      query: {
        'lender': lender,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param proposalId 
   * @returns FinanceProposalDto Success
   * @throws ApiError
   */
  public static getProposalsIndividual(
proposalId: number,
): CancelablePromise<FinanceProposalDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/proposals/individual/{proposalId}',
      path: {
        'proposalId': proposalId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns FinanceProposalDto Success
   * @throws ApiError
   */
  public static getProposalsIndividualByDeal(
dealId: number,
): CancelablePromise<FinanceProposalDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/proposals/individual/by-deal/{dealId}',
      path: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
